import React from "react";
import ReactDOM from "react-dom/client";
import "./ress.css";
import "./index.css";
import App from "./App";

const body = ReactDOM.createRoot(document.getElementById("achievements"));
body.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
